export default function projectLocations() {
	const $container = document.querySelector(".l-project-locations");

	if (!$container) {
		return;
	}

	const $prevTrigger = $container.querySelector("[data-prev]");
	const $nextTrigger = $container.querySelector("[data-next]");
	const $slidesContainer = $container.querySelector(
		".l-project-locations--projects-list"
	);
	const projectSlides = Array.from(
		$container.querySelectorAll(".l-project-locations--projects-list-item")
	);
	const mapPins = Array.from(
		$container.querySelectorAll(".l-project-locations--map-pin")
	);

	let currentIndex = 0;
	let prevIndex = false;

	let idFilter = (id, $el) => id == $el.dataset.id;

	let activateSlide = (curr, next) => {
		if (curr !== false) {
			let $currSlide = circularGet(projectSlides, curr);
			let $currPin = mapPins.filter(
				idFilter.bind(this, $currSlide.dataset.id)
			)[0];

			$currPin.classList.remove("is-active");
			$currSlide.classList.remove("is-visible");
		}

		let $nextSlide = circularGet(projectSlides, next);
		let $nextPin = mapPins.filter(
			idFilter.bind(this, $nextSlide.dataset.id)
		)[0];

		$nextPin.classList.add("is-active");
		$nextSlide.classList.add("is-visible");
	};

	activateSlide(false, currentIndex);

	mapPins.forEach($pin => {
		$pin.addEventListener("click", e => {
			prevIndex = currentIndex;
			currentIndex = projectSlides.findIndex(
				idFilter.bind(this, $pin.dataset.id)
			);
			activateSlide(prevIndex, currentIndex);
			e.preventDefault();
		});
	});

	$prevTrigger.addEventListener("click", e => {
		prevIndex = currentIndex;
		currentIndex--;
		activateSlide(prevIndex, currentIndex);
		e.preventDefault();
	});

	$nextTrigger.addEventListener("click", e => {
		prevIndex = currentIndex;
		currentIndex++;
		activateSlide(prevIndex, currentIndex);
		e.preventDefault();
	});

	// Set the height of container with absolutely positioned children, so content doesnt overlap on mobile
	const height = projectSlides.reduce(
		(acc, curr) => (curr.offsetHeight > acc ? curr.offsetHeight : acc),
		0
	);
	$slidesContainer.style.height = `${height}px`;
}

function circularGet(arr, index) {
	return arr[((index % arr.length) + arr.length) % arr.length];
}
